module.exports = __webpack_public_path__ + "img/photo_2023-12-01 19.34.59.840629f3.jpg";